import React from "react";

function Experience() {
  return (
    <><h1>Experience</h1><div className="section-content experience-full">
          <div className="curvy-road-full">
              {/* Curved dashed path */}
              <svg
                  viewBox="0 0 500 300"
                  preserveAspectRatio="xMidYMid meet"
                  className="road-svg-full"
              >
                  <path
                      d="M 40 250 Q 170 50 260 150 T 460 60"
                      stroke="#3c6e71"
                      strokeWidth="6"
                      fill="transparent"
                      strokeLinecap="round"
                      strokeDasharray="14 14" />
              </svg>

              {/* Point 1 – Frontend Developer Head */}
              <div className="road-point-full" style={{ top: "68%", left: "24%" }}>
                  <div className="pin-full" />
                  <p className="title">Frontend Developer Head</p>
                  <p className="org">Aarvasa</p>
                  <p className="date">Dec 2024 - May 2025</p>
              </div>

              {/* Point 2 – Data Scientist Intern */}
              <div className="road-point-full" style={{ top: "30%", left: "72%" }}>
                  <div className="pin-full" />
                  <p className="title">Data Scientist Intern</p>
                  <p className="org">Li &amp; Fung</p>
                  <p className="date">May 2025 - Jul 2025</p>
              </div>
          </div>
      </div></>
  );
}

export default Experience;
